module.exports = __webpack_public_path__ + "img/MuayThaiChampion_FreeSpinsFeature_Loading.ebe8ac96.jpg";